module.exports = __webpack_public_path__ + "static/media/private-cremation-lw.ae66eecf.png";